<template>
  <div class="kv-ve-box-spacing">
    <div v-if="label" class="kv-ve-box-spacing__label-row">
      <label class="kv-ve-box-spacing__label">{{ label }}</label>
    </div>

    <div class="kv-ve-box-spacing__grid" :aria-label="label || t('visual_editor-spacing')">
      <input
        class="kv-ve-box-spacing__input kv-ve-box-spacing__input--top"
        type="number"
        :min="min"
        :max="max"
        :step="step"
        :value="safe.top"
        :aria-label="t('visual_editor-top')"
        @input="setSide('top', $event.target.value)"
      />
      <input
        class="kv-ve-box-spacing__input kv-ve-box-spacing__input--right"
        type="number"
        :min="min"
        :max="max"
        :step="step"
        :value="safe.right"
        :aria-label="t('visual_editor-right')"
        @input="setSide('right', $event.target.value)"
      />
      <input
        class="kv-ve-box-spacing__input kv-ve-box-spacing__input--bottom"
        type="number"
        :min="min"
        :max="max"
        :step="step"
        :value="safe.bottom"
        :aria-label="t('visual_editor-bottom')"
        @input="setSide('bottom', $event.target.value)"
      />
      <input
        class="kv-ve-box-spacing__input kv-ve-box-spacing__input--left"
        type="number"
        :min="min"
        :max="max"
        :step="step"
        :value="safe.left"
        :aria-label="t('visual_editor-left')"
        @input="setSide('left', $event.target.value)"
      />

      <div class="kv-ve-box-spacing__box" aria-hidden="true">
        <div class="kv-ve-box-spacing__box-inner">{{ centerLabel }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "VeBoxSpacingPicker",
  model: { prop: "value", event: "input" },
  props: {
    label: { type: String, default: "" },
    centerLabel: { type: String, default: "" },
    value: {
      type: Object,
      default: () => ({ top: 0, right: 0, bottom: 0, left: 0 }),
    },
    min: { type: Number, default: 0 },
    max: { type: Number, default: 999 },
    step: { type: Number, default: 1 },
  },
  computed: {
    safe() {
      const v = this.value || {};
      const toNum = (x) => {
        const n = Number(x);
        return Number.isFinite(n) ? n : 0;
      };
      return {
        top: toNum(v.top),
        right: toNum(v.right),
        bottom: toNum(v.bottom),
        left: toNum(v.left),
      };
    },
  },
  methods: {
    t(term, replaces) {
      return this.$root.t(term, replaces);
    },
    setSide(side, raw) {
      const n = Number(raw);
      const next = Number.isFinite(n) ? Math.min(this.max, Math.max(this.min, Math.round(n))) : this.safe[side];
      this.$emit("input", { ...this.safe, [side]: next });
    },
  },
};
</script>

<style scoped lang="less">
.kv-ve-box-spacing__label-row {
  margin-bottom: 8px;
}
.kv-ve-box-spacing__label {
  margin: 0;
  font-size: 12px;
  font-weight: 600;
  color: #344054;
}

.kv-ve-box-spacing__grid {
  display: grid;
  grid-template-columns: 64px 1fr 64px;
  grid-template-rows: 32px 74px 32px;
  grid-template-areas:
    ". top ."
    "left box right"
    ". bottom .";
  align-items: center;
  gap: 8px;
}

.kv-ve-box-spacing__input {
  width: 64px;
  height: 32px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 0 10px;
  font-size: 12px;
  color: #101828;
  font-variant-numeric: tabular-nums;
}
.kv-ve-box-spacing__input:focus {
  outline: none;
  border-color: rgba(42, 170, 76, 0.65);
  box-shadow: 0 0 0 4px rgba(42, 170, 76, 0.12);
}

.kv-ve-box-spacing__input--top {
  grid-area: top;
  justify-self: center;
}
.kv-ve-box-spacing__input--right {
  grid-area: right;
  justify-self: end;
}
.kv-ve-box-spacing__input--bottom {
  grid-area: bottom;
  justify-self: center;
}
.kv-ve-box-spacing__input--left {
  grid-area: left;
  justify-self: start;
}

.kv-ve-box-spacing__box {
  grid-area: box;
  height: 74px;
  border: 1px dashed #d0d5dd;
  border-radius: 14px;
  background: #f9fafb;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.kv-ve-box-spacing__box-inner {
  font-size: 11px;
  font-weight: 500;
  color: #667085;
}
</style>




